import request from '@/utils/request';
import { QueryTagParams, TagListResponse, UpdateTagParams, CreateTagParams, Tag } from '@/types/tag';
export interface UpdateBrandTagParams extends Partial<CreateTagParams> {
  tagIds: string [];
}

export const tagService = {
  // 获取标签列表
    getTagList: (params: QueryTagParams) => {
       return request.get<TagListResponse>('/api/admin/product/tags', { params });
     },
  // 获取已启用的标签
    getEnabledTags: () => {
       return request.get<Tag []>('/api/admin/product/tags/getEnabledTags');
     },

  // 获取品牌标签
    getBrandTags: (brandId: number) => {
      return request.get<Tag []>(`/api/admin/product/tags/getBrandTags/${brandId}`);
    },

  // 获取商品标签
    getProductTags: (productId: number) => {
      return request.get<Tag []>(`/api/admin/product/tags/getProductTags/${productId}`);
    },

  // 获取美团商品标签
    getMeituanProductTags: (meituanProductId: number) => {
      return request.get<Tag []>(`/api/admin/product/tags/getMeituanProductTags/${meituanProductId}`);
    },
  // 创建标签
     createTag: (data: CreateTagParams) => {
       return request.post<Tag>('/api/admin/product/tags', data);
     },


  // 更新标签
     updateTag: (id: number, data: UpdateTagParams) => {
       return request.put<Tag>(`/api/admin/product/tags/${id}`, data);
     },

  // 删除标签
   deleteTag: (id: number) => {
     return request.delete(`/api/admin/product/tags/${id}`);
   },

   // 更新品牌标签
    updateBrandTags: (brandId: number, data: UpdateBrandTagParams) => {
      return request.post(`/api/admin/product/tags/updateBrandTags/${brandId}`, data);
    },
 };
